module.exports = __webpack_public_path__ + "img/symbol_4.f1cc6188.png";